<template>
    <div class="panel panel-visible widget-client_subs">
        <div class="panel-heading">
            <div class="panel-title hidden-xs">
                <span class="glyphicon glyphicon-credit-card"></span>
                Продажи
            </div>

        </div>
        <div class="panel-body">
            <table class="table table-striped table-hover client_subs">
                <thead>
                <tr>
                    <th> Абонемент</th>
                    <th> Статус</th>
                    <th> Остаток</th>
                    <th> Годен до</th>
                    <th v-if="showActions"></th>
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="(subscription, index) in subscriptionList"
                        v-bind:key="index"
                        v-on:click="selectSubscription(subscription)"
                        :class="{
                            'primary': selectedSubscription !== null && selectedSubscription.id === subscription.id,
                        }"
                        class="row-select"
                >
                    <td :class="{'opacity-05': subscription.count === 0,}">
                        <span v-if="data.subscriptions.length > 0">
                            {{data.subscriptions.find(row => row.id === subscription.subscriptionId).name}}
                        </span>
                        <span v-else class="glyphicon glyphicon-time">
                            ---
                        </span>
                    </td>
                    <td :class="{'opacity-05': subscription.count === 0,}">
                        <span class="label" :class="{'label-success': subscription.status === 1, 'label-danger': subscription.status === 0}">
                            {{subscription.status === 1 ? 'Активирован' : 'Не активирован'}}
                        </span>
                    </td>
                    <td :class="{'opacity-05': subscription.count === 0,}">{{subscription.count}}</td>
                    <td :class="{'opacity-05': subscription.count === 0,}">
                        <span v-if="subscription.status === 1">
                            {{subscription.dateExpire | dateFormat('dd.mm.yyyy')}}
                        </span>
                        <span v-else>---</span>
                    </td>
                    <td v-if="showActions">
                        <drop-down-button classes="btn-info btn-sm">
                            <li>
                                <a v-on:click="setHide(subscription)">
                                    Скрыть
                                </a>
                            </li>
                            <li  v-if="subscription.count === data.subscriptions.find(element => element.id === subscription.subscriptionId).count" class="divider"></li>
                            <li v-if="subscription.count === data.subscriptions.find(element => element.id === subscription.subscriptionId).count">
                                <a v-on:click="remove(subscription)">
                                    Удалить
                                </a>
                            </li>
                        </drop-down-button>
                    </td>
                </tr>
                <tr v-show="subscriptionList.length === 0">
                    <td :colspan="showActions === true ? 5 : 4" class="text-center">Нет активных абонементов</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="panel-menu">

            <input type="button" v-if="showAdd" class="btn btn-alert mr10" v-on:click.prevent="subscriptionAddCountShowModal" value="Добавить занятия" :disabled="selectedSubscription === null || selectedSubscription.status === 0">

            <input type="button" class="btn btn-success mr10" v-on:click.prevent="subscriptionAddDaysShowModal" value="Продлить" :disabled="selectedSubscription === null || selectedSubscription.status === 0">

            <input type="button" v-if="showAdd" class="btn btn-info mr10" v-on:click.prevent="subscriptionSurchargeShowModal" value="Доплата" :disabled="selectedSubscription === null || selectedSubscription.status === 0">

            <input type="button" class="btn btn-warning mr10" v-on:click.prevent="activateSubscription" value="Активировать" :disabled="selectedSubscription === null || selectedSubscription.status === 1">

        </div>


        <modal name="subscription-add-count" height="auto">
            <loading :active.sync="modals.subscriptionAddCount.isLoading" :z-index="3" color="#4c4a49" :is-full-page="false"/>
            <div class="panel panel-visible" v-if="selectedSubscription">
                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        <span class="glyphicon glyphicon-circle-arrow-up"/>
                        Добавление занятий
                    </div>

                </div>
                <div class="panel-body admin-form">
                    <div class="row section">
                        <div class="col-md-12">
                            <label class="field-label">Количество занятий</label>
                            <label class="field prepend-icon">
                                <input type="text" class="gui-input" v-model="modals.subscriptionAddCount.count" placeholder="5 занятий">
                                <label class="field-icon">
                                    <i class="glyphicon glyphicon-circle-arrow-up"/>
                                </label>
                            </label>
                        </div>
                    </div>
                    <div class="row section">
                        <div class="col-md-12">
                            <label class="field-label">Сумма</label>
                            <label class="field prepend-icon">
                                <input type="text" class="gui-input" v-model="modals.subscriptionAddCount.sum">
                                <label class="field-icon">
                                    <i class="glyphicon glyphicon-rub"/>
                                </label>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="field-label">Тип платежа</label>
                            <label class="field select">
                                <select v-model="modals.subscriptionAddCount.paymentType">
                                    <option v-for="(type, index) in this.data.paymentTypes" v-bind:key="index" :value="type.id">
                                        {{type.name}}
                                    </option>
                                </select>

                                <i class="arrow double"/>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="panel-footer admin-form">
                    <button type="button" v-on:click.prevent="subscriptionAddCount" :disabled="isNaN(modals.subscriptionAddCount.count)" class="button btn-primary">Сохранить</button>
                </div>

            </div>
        </modal>
        <modal name="subscription-add-days" height="auto">
            <loading :active.sync="modals.subscriptionAddDays.isLoading" :z-index="3" color="#4c4a49" :is-full-page="false"/>
            <div class="panel panel-visible" v-if="selectedSubscription">
                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        <span class="glyphicon glyphicon-calendar"/>
                        Продление абонемента
                    </div>

                </div>
                <div class="panel-body admin-form">
                    <div class="row section">
                        <div class="col-md-12">
                            <label class="field-label">Количество дней</label>
                            <label class="field prepend-icon">
                                <input type="text" class="gui-input" v-model="modals.subscriptionAddDays.days" placeholder="10 дней">
                                <label class="field-icon">
                                    <i class="glyphicon glyphicon-calendar"/>
                                </label>
                            </label>
                        </div>
                    </div>
                    <div class="row section">
                        <div class="col-md-12">
                            <label class="field-label">Сумма</label>
                            <label class="field prepend-icon">
                                <input type="text" class="gui-input" v-model="modals.subscriptionAddDays.sum">
                                <label class="field-icon">
                                    <i class="glyphicon glyphicon-rub"/>
                                </label>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="field-label">Тип платежа</label>
                            <label class="field select">
                                <select v-model="modals.subscriptionAddDays.paymentType">
                                    <option v-for="(type, index) in this.data.paymentTypes" v-bind:key="index" :value="type.id">
                                        {{type.name}}
                                    </option>
                                </select>

                                <i class="arrow double"/>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="panel-footer admin-form">
                    <button type="button" v-on:click.prevent="subscriptionAddDays" :disabled="isNaN(modals.subscriptionAddDays.days)" class="button btn-primary">Сохранить</button>
                </div>

            </div>
        </modal>
        <modal name="subscription-surcharge" height="auto">
            <div class="panel panel-visible">
                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        <span class="fa fa-money"/>
                        Доплата (разрешить занятие на вечер)
                    </div>

                </div>
                <div class="panel-body admin-form">
                    <div class="row section">
                        <div class="col-md-12">
                            <label class="field-label">Сумма</label>
                            <label class="field prepend-icon">
                                <input type="text" class="gui-input" v-model="modals.surcharge.sum">
                                <label class="field-icon">
                                    <i class="glyphicon glyphicon-rub"/>
                                </label>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label class="field-label">Тип платежа</label>
                            <label class="field select">
                                <select v-model="modals.surcharge.paymentType">
                                    <option v-for="(type, index) in this.data.paymentTypes" v-bind:key="index" :value="type.id">
                                        {{type.name}}
                                    </option>
                                </select>

                                <i class="arrow double"/>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="panel-footer admin-form">
                    <button type="button" v-on:click.prevent="surchargeAdd" class="button btn-primary">Применить</button>
                </div>

            </div>
        </modal>
    </div>
</template>

<script>
    import Client from '../../models/Client';
    import ClientSubscription from "../../models/ClientSubscription";
    import dateformat from "dateformat";
    import Cashflow from "../../models/Cashflow";
    import moment from "moment";
    import Subscription from "../../models/Subscription";
    import DropDownButton from "../data/DropDownButton";
    export default {
        components: {DropDownButton},
        comments: {
            Loading: () => import('vue-loading-overlay'),
            dropDownButton: () => import('../data/DropDownButton'),
        },
        props: {
            showAdd: {
                type: Boolean,
                default: false,
            },
            showActions: {
                type: Boolean,
                default: false,
            },
            showEnded: {
                type: Boolean,
                default: true,
            },
            client: Client,
        },

        async beforeCreate() {
            let subscriptionsResponse;
            [subscriptionsResponse] = await Promise.all([
                Subscription.getList(1, 999),
            ]);

            this.data.subscriptions = subscriptionsResponse.data;
        },
        data() {
            return {
                data: {
                    subscriptions: [],
                    paymentTypes: Cashflow.getTypesPayment(),
                },
                modals: {
                    subscriptionAddCount: {
                        isLoading: false,
                        count: '',
                        sum: '',
                        paymentType: Cashflow.PAYMENT_TYPE_CASH,
                    },
                    subscriptionAddDays: {
                        isLoading: false,
                        days: '',
                        sum: '',
                        paymentType: Cashflow.PAYMENT_TYPE_CASH,
                    },
                    surcharge: {
                        sum: '',
                        paymentType: Cashflow.PAYMENT_TYPE_CASH,
                        apply: false,
                    },
                },

                selectedSubscription: null,
                subscriptions: this.client.subscriptions,
            };
        },
        computed: {
            subscriptionList: function() {
                if (this.showEnded === true) {
                    return this.subscriptions.filter(subscription => subscription.hide === 0);
                }

                return this.subscriptions.filter(subscription => {
                    if (subscription.count === 0) {
                        return false;
                    }
                  if (subscription.hide === 1) {
                    return false;
                  }
                    if (subscription.dateExpire && moment(subscription.dateExpire, 'YYYY-MM-DD').endOf('day') <= moment()) {
                        return false;
                    }
                    if (subscription.status === ClientSubscription.STATUS_DISABLED && subscription.createdAt < '1594760400') { // Только созданные после 2020-07-15
                        return false;
                    }
                    return true;
                });
            },
        },
        watch: {
            'client.subscriptions': function(value) {
                this.subscriptions = value;
            },
        },
        methods: {

            selectSubscription(subscription) {
                if (this.selectedSubscription !== null && this.selectedSubscription.id === subscription.id) {
                    this.selectedSubscription = null;
                } else {
                    if (subscription.count > 0) {
                        this.selectedSubscription = subscription;
                    }
                }
                this.$emit('subscription-update', this.selectedSubscription);
            },

            subscriptionAddCountShowModal() {
                this.$modal.show('subscription-add-count');
            },
            subscriptionAddDaysShowModal() {
                this.$modal.show('subscription-add-days');
            },
            subscriptionSurchargeShowModal() {
                this.$modal.show('subscription-surcharge');
            },
            async activateSubscription() {
                if (confirm(`Активировать абонемент\n${this.data.subscriptions.find(row => row.id === this.selectedSubscription.subscriptionId).name}?`) === false) {
                    return;
                }

                let response = await this.selectedSubscription.activate();
                this.selectedSubscription.status = ClientSubscription.STATUS_ACTIVE;
                this.selectedSubscription.dateActivate = dateformat(new Date(), 'yyyy-mm-dd');
                this.selectedSubscription.dateExpire = response.date_expire;
            },

            surchargeAdd() {
                this.modals.surcharge.apply = true;
                this.$emit('surcharge-add', this.modals.surcharge);
                this.$modal.hide('subscription-surcharge');
            },

            async subscriptionAddDays() {
                this.modals.subscriptionAddDays.isLoading = true;

                await this.selectedSubscription.addDays(
                    this.modals.subscriptionAddDays.days,
                    this.modals.subscriptionAddDays.sum,
                    this.modals.subscriptionAddDays.paymentType,
                );
                let newDate = moment(this.selectedSubscription.dateExpire, 'YYYY-MM-DD');
                newDate.add(this.modals.subscriptionAddDays.days, 'days');
                this.selectedSubscription.dateExpire = newDate.format('YYYY-MM-DD');

                this.modals.subscriptionAddDays.isLoading = true;

                this.$modal.hide('subscription-add-days');

                this.modals.subscriptionAddDays.days = '';
                this.modals.subscriptionAddDays.sum = '';
                this.modals.subscriptionAddDays.paymentType = Cashflow.PAYMENT_TYPE_CASH;
            },

            async subscriptionAddCount() {
                this.modals.subscriptionAddCount.isLoading = true;

                await this.selectedSubscription.addCount(
                    this.modals.subscriptionAddCount.count,
                    this.modals.subscriptionAddCount.sum,
                    this.modals.subscriptionAddCount.paymentType,
                );
                this.selectedSubscription.count += Number(this.modals.subscriptionAddCount.count);

                this.modals.subscriptionAddCount.isLoading = true;

                this.$modal.hide('subscription-add-count');

                this.modals.subscriptionAddCount.count = '';
                this.modals.subscriptionAddCount.sum = '';
                this.modals.subscriptionAddCount.paymentType = Cashflow.PAYMENT_TYPE_CASH;
            },

            async setHide(subscription) {
                if (confirm('Скрыть абонемент?') === false) {
                    return false;
                }

                try {
                    await subscription.setHide();
                    const index = this.subscriptions.findIndex(element => subscription.id === element.id);
                    this.subscriptions.splice(index, 1);
                    this.$notify({
                        text: 'Сохранено'
                    });
                } catch (e) {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка. Не удалось скрыть абонемент'
                    });
                }

            },

            async remove(subscription) {
                if (confirm('Удалить абонемент?') === false) {
                    return false;
                }

                try {
                    await subscription.remove();
                    const index = this.subscriptions.findIndex(element => subscription.id === element.id);
                    this.subscriptions.splice(index, 1);
                    this.$notify({
                        text: 'Сохранено'
                    });
                } catch (e) {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка. Не удалось скрыть абонемент'
                    });
                }

            },
        },
    }
</script>
